import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import ObjectTypeLIst from './ObjectTypeLIst';
import { Link } from 'react-router-dom';

let permisionActions = [];
class ObjectTypes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.objectTypeState.pageSize,
                pageIndex: this.props.objectTypeState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.OBJECT_TYPES);
        this.props.getListObjectTypes(this.state.filters);
    }

    render() {
        const { t, objectTypeState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, objectTypes } = objectTypeState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'objectTypes'}
                        titleHeader={t('navigation.objectTypes')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.OBJECT_TYPES.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <ObjectTypeLIst loading={isFetching}
                                  permisions={permisionActions}
                                  objectTypes={objectTypes}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteObjectType}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListObjectTypes(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListObjectTypes(newFilters);
    }

    onDeleteObjectType = (item) => {
        this.props.deleteObjectTypeDetail(item, {
            filters: {
                pageSize: this.props.objectTypeState.pageSize,
                pageIndex: this.props.objectTypeState.pageIndex
            }
        });
    }
}


export default ObjectTypes
